/* Oraloa · barre « livraison gratuite » de l'en-tête.
   Lit le vrai panier (/cart.js), demande à la fonction serveur « livraison-gratuite » ce qu'il
   manque selon la règle du paiement, puis affiche « Plus que 18 € … » ou « Vous bénéficiez … ».
   Se met à jour quand le panier change (ajout, quantité, suppression), sans requête inutile :
   un seul appel à la fois, les réponses en retard sont ignorées, un résultat identique est
   gardé 10 minutes dans l'onglet. Erreur ou pays sans gratuité : la barre reste cachée. */
(function () {
  'use strict';
  var CLE = 'oraloa-livraison-gratuite', DUREE = 10 * 60 * 1000;

  function montant(cents, devise, langue) {
    var v = cents / 100, entier = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(langue || undefined, { style: 'currency', currency: devise,
        minimumFractionDigits: entier ? 0 : 2, maximumFractionDigits: entier ? 0 : 2 }).format(v);
    } catch (e) { return v.toFixed(entier ? 0 : 2) + ' ' + devise; }
  }

  /* PAYS SANS LIVRAISON OFFERTE (4 novembre 2026, Haïm : « un petit message sympa adapté au pays ») :
     bonjour dans la langue du pays, son drapeau, et une phrase qui ne promet aucune gratuité. */
  var SALUTS = {
    IL: 'Shalom', JP: 'Konnichiwa', KR: 'Annyeong', CN: 'Nǐ hǎo', TW: 'Nǐ hǎo', HK: 'Nǐ hǎo', TH: 'Sawasdee', VN: 'Xin chào',
    IN: 'Namaste', PH: 'Kumusta', ID: 'Halo', MY: 'Halo', TR: 'Merhaba', GR: 'Yassou', CY: 'Yassou',
    AE: 'Marhaba', SA: 'Marhaba', QA: 'Marhaba', KW: 'Marhaba', BH: 'Marhaba', OM: 'Marhaba', JO: 'Marhaba', LB: 'Marhaba', EG: 'Marhaba',
    MA: 'Salam', DZ: 'Salam', TN: 'Salam', PL: 'Cześć', CZ: 'Ahoj', SK: 'Ahoj', HU: 'Szia', RO: 'Salut', UA: 'Pryvit',
    SE: 'Hej', DK: 'Hej', NO: 'Hei', FI: 'Moi', IS: 'Halló', EE: 'Tere', LV: 'Sveiki', LT: 'Labas', HR: 'Bok', SI: 'Živjo',
    MT: 'Bonġu', PT: 'Olá', BR: 'Olá', ES: 'Hola', MX: 'Hola', AR: 'Hola', CL: 'Hola', CO: 'Hola', PE: 'Hola', UY: 'Hola',
    EC: 'Hola', CR: 'Hola', PA: 'Hola', DO: 'Hola', IT: 'Ciao', SM: 'Ciao', DE: 'Hallo', NL: 'Hallo', AT: 'Servus', CH: 'Grüezi',
    FR: 'Bonjour', BE: 'Bonjour', LU: 'Bonjour', MC: 'Bonjour', AU: 'G’day', NZ: 'Kia ora'
  };
  function drapeau(cc) {
    return /^[A-Z]{2}$/.test(cc) ? String.fromCodePoint(0x1F1E6 + cc.charCodeAt(0) - 65, 0x1F1E6 + cc.charCodeAt(1) - 65) + ' ' : '';
  }
  function salut(el) {
    var cc = el.getAttribute('data-country') || '', p = el.getAttribute('data-pays') || '';
    return p && drapeau(cc) + p.split('{salut}').join(SALUTS[cc] || 'Hello');
  }

  /* écrit la phrase avec le montant en gras, en texte seulement (jamais de HTML venu d'ailleurs) */
  function rendre(el, r, vide) {
    var cible = el.querySelector('[data-olg-texte]');
    if (!cible) return;
    /* la ligne était réservée dès le chargement : la page ne bouge pas */
    el.removeAttribute('data-attente');
    var bonjour = r && r.available === false ? salut(el) : '';
    if (!bonjour && (!r || !r.available || r.currency !== el.getAttribute('data-currency'))) { el.hidden = true; return; }
    while (cible.firstChild) cible.removeChild(cible.firstChild);
    if (bonjour) { cible.textContent = bonjour; el.hidden = false; return; }
    /* panier vide : pas de montant (4 novembre 2026), le seuil dépend de ce qui sera choisi (stock ou POD) */
    if (vide && el.getAttribute('data-vide')) cible.appendChild(document.createTextNode(el.getAttribute('data-vide')));
    else if (r.attained) cible.appendChild(document.createTextNode(el.getAttribute('data-atteinte') || ''));
    else {
      /* la phrase mène aux kits qui comblent l'écart, du moins cher au plus cher (23 octobre 2026) */
      var lien = el.getAttribute('data-lien'), dans = cible;
      if (lien && lien.charAt(0) === '/') {
        dans = document.createElement('a');
        dans.className = 'olg__lien';
        dans.href = lien + '?filter.v.price.gte=' + Math.ceil(r.remaining / 100) + '&filter.v.availability=1&sort_by=price-ascending';
        cible.appendChild(dans);
      }
      var morceaux = (el.getAttribute('data-reste') || '').split('{amount}');
      dans.appendChild(document.createTextNode(morceaux[0] || ''));
      var fort = document.createElement('strong');
      fort.textContent = montant(r.remaining, r.currency, el.getAttribute('data-locale'));
      dans.appendChild(fort);
      dans.appendChild(document.createTextNode(morceaux.slice(1).join('{amount}')));
    }
    /* Espagne sans province connue : seuil du continent, on le dit (« (península) ») */
    var precision = el.getAttribute('data-precision');
    if (precision) cible.appendChild(document.createTextNode(' ' + precision));
    el.hidden = !cible.textContent.trim();
  }

  function demarrer() {
    var zones = Array.prototype.slice.call(document.querySelectorAll('[data-oraloa-livraison]'));
    if (!zones.length || window.__oraloaLivraisonGratuite) return;
    window.__oraloaLivraisonGratuite = true;
    var z0 = zones[0], endpoint = z0.getAttribute('data-endpoint') || '';
    if (!/^https:\/\/[a-z0-9-]+\.supabase\.co\/functions\/v1\/livraison-gratuite$/.test(endpoint)) return;
    var numero = 0, minuterie = null;

    /* Sur téléphone, la phrase agrandit le bandeau orange. Le thème le cache en le remontant de
       --toolbar-height quand on fait défiler : on lui donne la vraie hauteur, et on rend
       l'ancienne valeur dès que la phrase disparaît (ou sur grand écran). */
    var cale = null;
    function caler() {
      var hd = document.querySelector('.header-maxdesign'), t = hd && hd.querySelector('.tmd');
      if (!t) return;
      var mobile = window.matchMedia ? window.matchMedia('(max-width: 1024px)').matches : false;
      var visible = mobile && zones.some(function (el) { return !el.hidden && t.contains(el); });
      if (visible) {
        if (cale === null) cale = hd.style.getPropertyValue('--toolbar-height');
        hd.style.setProperty('--toolbar-height', t.offsetHeight + 'px');
      } else if (cale !== null) {
        if (cale) hd.style.setProperty('--toolbar-height', cale); else hd.style.removeProperty('--toolbar-height');
        cale = null;
      }
    }
    function tout(r, vide) { zones.forEach(function (el) { rendre(el, r, vide); }); caler(); }
    window.addEventListener('resize', function () { caler(); });
    function lireCache(cle) {
      try { var c = JSON.parse(sessionStorage.getItem(CLE) || 'null'); return c && c.cle === cle && Date.now() - c.t < DUREE ? c.r : null; } catch (e) { return null; }
    }
    function ecrireCache(cle, r) { try { sessionStorage.setItem(CLE, JSON.stringify({ cle: cle, t: Date.now(), r: r })); } catch (e) {} }

    function demander(panier) {
      var n = ++numero;
      var corps = {
        country: z0.getAttribute('data-country') || '', province: z0.getAttribute('data-province') || '',
        currency: panier.currency || z0.getAttribute('data-currency') || '', total: panier.total_price || 0,
        items: (panier.items || []).map(function (i) {
          return { variant_id: i.variant_id, sku: i.sku || '', quantity: i.quantity, grams: i.grams || 0, requires_shipping: i.requires_shipping !== false };
        })
      };
      var vide = !corps.items.some(function (i) { return i.requires_shipping && i.quantity > 0; });
      var cle = JSON.stringify(corps), memo = lireCache(cle);
      if (memo) { tout(memo, vide); return Promise.resolve(memo); }
      /* texte brut : pas de requête préalable du navigateur, la réponse arrive plus vite */
      return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: cle, credentials: 'omit' })
        /* serveur en panne : la barre se cache (jamais le message des pays sans livraison offerte) */
        .then(function (rep) { return rep.ok ? rep.json() : null; })
        .then(function (r) { if (n !== numero) return; if (r && typeof r.available === 'boolean') ecrireCache(cle, r); tout(r, vide); return r; })
        .catch(function () { if (n === numero) tout(null); });
    }
    function actualiser(panier) {
      if (panier && typeof panier.total_price === 'number' && Array.isArray(panier.items)) return demander(panier);
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (rep) { return rep.json(); }).then(demander).catch(function () { tout(null); });
    }
    function bientot(panier) { clearTimeout(minuterie); minuterie = setTimeout(function () { actualiser(panier); }, 350); }

    /* le panier change : réponses des appels /cart/add|change|update|clear du thème et des applis */
    var MODIF = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    if (window.fetch) {
      var fetchAvant = window.fetch;
      window.fetch = function (ressource) {
        var p = fetchAvant.apply(this, arguments);
        try { var url = typeof ressource === 'string' ? ressource : ressource && ressource.url; if (url && MODIF.test(url)) p.then(function () { bientot(); }, function () {}); } catch (e) {}
        return p;
      };
    }
    var ouvrirAvant = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      try { if (MODIF.test(String(url))) this.addEventListener('loadend', function () { bientot(); }); } catch (e) {}
      return ouvrirAvant.apply(this, arguments);
    };
    ['cart:updated', 'cart:refresh', 'on:cart:add', 'on:cart:change', 'theme:cart:change'].forEach(function (nom) {
      document.addEventListener(nom, function (e) { var d = e && e.detail; bientot(d && (d.cart || d)); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) bientot(); });
    actualiser();
  }

  window.OraloaLivraisonGratuite = { montant: montant, rendre: rendre, demarrer: demarrer };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
